import { render, staticRenderFns } from "./ExamSelect.vue?vue&type=template&id=85479516&"
import script from "./ExamSelect.vue?vue&type=script&lang=js&"
export * from "./ExamSelect.vue?vue&type=script&lang=js&"
import style0 from "./ExamSelect.vue?vue&type=style&index=0&id=85479516&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports